// import './img.scss';

export { default } from './Img';
export { default as template } from './img.tpl';
